console.log("hello from since date reviews 3!!");
document.addEventListener("DOMContentLoaded", function () {
  $(window).resize();
  applySinceDateReviews();
});

function applySinceDateReviews() {
  let reviewDates = document.getElementsByClassName("reviewCreatedDate");
  const nowTime = new Date().getTime();
  const rtf = new Intl.RelativeTimeFormat("fr-FR");

  for (let i = 0; i < reviewDates.length; i++) {
    const raw = reviewDates[i].textContent.trim();
    const [day, month, year, time] = raw.replace(" ", "/").split("/");
    const iso = `${year}-${month}-${day}T${time}`;
    let date = new Date(iso);

    const diff = date.getTime() - nowTime;
    let relativeDate = "";

    if (Math.abs(diff) < 60000) {
      const seconds = Math.floor(diff / 1000);
      relativeDate = rtf.format(seconds, "second");
    } else if (Math.abs(diff) < 3600000) {
      const minutes = Math.floor(diff / 60000);
      relativeDate = rtf.format(minutes, "minute");
    } else if (Math.abs(diff) < 86400000) {
      const hours = Math.floor(diff / 3600000);
      relativeDate = rtf.format(hours, "hour");
    } else if (Math.abs(diff) < 604800000) {
      const days = Math.floor(diff / 86400000);
      relativeDate = rtf.format(days, "day");
    } else if (Math.abs(diff) < 2592000000) {
      const weeks = Math.floor(diff / 604800000);
      relativeDate = rtf.format(weeks, "week");
    } else if (Math.abs(diff) < 31536000000) {
      const months = Math.floor(diff / 2592000000);
      relativeDate = rtf.format(months, "month");
    } else {
      const years = Math.floor(diff / 31536000000);
      relativeDate = rtf.format(years, "year");
    }

    reviewDates[i].textContent = relativeDate;
  }
}
